<template>
<div class="index">
    <div class="wx">
        <div class="wxitem">
            <p>物流查询微信</p>
            <img src="/static/images/wj.png"/>
        </div>
        <!-- <div class="wxitem">
            <p>销售咨询微信</p>
            <img src="/static/images/mq.png"/>
        </div> -->
    </div>
    <index-top></index-top>
    <div class="product">
        <div class="product-title">
            <h2>
                SERVICE
            </h2>
            <h3>
                产品服务
            </h3>
        </div>
            <div class="products">
                <div class="productItemV2">
                    <a href="/shipping?id=0">
                        <i class="iconfont icon-icon-qqzy1"></i>
                        <h3>国际快线</h3>
                        <p><b>全过程实现快收快出</b></p>
                    </a>
                </div>
                <div class="productItemV2">
                    <a href="/shipping?id=1">
                        <i class="iconfont icon-icon-ddly"></i>
                        <h3>国际专线</h3>
                        <p><b>包机直飞、多口岸固定仓位</b></p>
                    </a>
                </div>
                <div class="productItemV2">
                    <a href="/shipping?id=2">
                        <i class="iconfont icon-icon-jgtr"></i>
                        <h3>FBA大货</h3>
                        <p><b>国内包机直飞航班</b></p>
                    </a>
                </div>
                <div class="productItemV2">
                    <a href="https://www.drocen.com/" target="_blank">
                        <i class="iconfont icon-icon-sfg"></i>
                        <h3>一件代发</h3>
                        <p><b>出库发货时间快</b></p>
                    </a>
                </div>
                <div class="productItemV2">
                    <a href="/warehouse?id=1">
                        <i class="iconfont icon-icon-hz"></i>
                        <h3>集运转运</h3>
                        <p><b>1V1对接服务</b></p>
                    </a>
                </div>
            </div>
    </div>
    <div class="about">
        <div class="about-text">
            <h2>ABOUT US</h2>
            <h3>关于我们</h3>
            <p>
                广州行运易国际供应链有限公司 专注于打造高性价比的优质国际专线渠道，凭借精细化运营管理，智能化核心系统，以及整合全球领先物流资源，实现头程，清关，派送全链条无缝流转，最大程度以快时效、低成本为广大跨境电商灵活提供定制化的优质物流服务。公司坚持以客为本，服务领先的理念，致力满足更多跨境电商企业多样化的物流需求。
致力于为跨境电商提供全球领先的优质物流和智能化仓储服务。公司旗下拥有三大类、50余种物流产品和服务，全面覆盖物流、仓储服务以及反向物流解决方案，专注满足跨境电商卖价多样化的物流需求，为其物流提供定制化、智能化物流服务解决方案。
            </p>
        </div>
        <img src="../images/urban-887.png" />
    </div>
    <div class="news">
            <div class="text">
                <p class="title">
                    联 络 我 们
                </p>
            </div>

            <div class="text2"  style="margin-bottom:20px;">
                <p class="title2">
                    获取优惠报价、免费试发
                </p>
                <div class="labels">
                    <div class="labelItem" style="margin-right:20px">
                        <p class="labelTitle">
                            姓名 <span class="labelR">*</span>
                        </p>
                        <input class="labelInput" aria-placeholder="有留下您的姓名" autocomplete="off"  v-model="postData.Contact"/>
                    </div>
                    <div class="labelItem">
                        <p class="labelTitle">
                            电话 <span class="labelR">*</span>
                        </p>
                        <input class="labelInput" aria-placeholder="有留下您的电话" autocomplete="off" v-model="postData.Phone" />
                    </div>
                    <div style="clear:both"></div>
                    <div style="margin-top:30px;clear:both">
                        <button @click="add()">立即咨询</button>
                    </div>

                </div>
            </div>

        <div class="center" style="height:310px">
            <div class="contactusList">

                <div class="contactusItem">
                    <img src="../images/gz.jpg" class="bg"/>
                    <h3>
                        广州总部
                    </h3>
                    <p>
                        <img src="../images/ic_home.png"/>
                        广东省白云区集贤路集安街3号, 凯云商务中心
                    </p>
                    <p>
                        <img src="../images/ic_phone.png"/>
                        15920931685
                    </p>
                    <p>
                        <img src="../images/ic_message.png"/>
                        duanyixiang@xingyunyi.cn
                    </p>
                </div>

                <div class="contactusItem">
                    <img src="../images/sz.jpg" class="bg"/>
                    <h3>
                        深圳分公司
                    </h3>
                    <p>
                        <img src="../images/ic_home.png"/>
                        深圳市龙岗区坂田街道五和社区1985园中园一区8号综合楼102
                    </p>
                    <p>
                        <img src="../images/ic_phone.png"/>
                        18676373282
                    </p>
                    <p>
                        <img src="../images/ic_message.png"/>
                        tanronghui@xingyunyi.cn
                    </p>
                </div>

                <div class="contactusItem" style="margin-right:0">
                    <img src="../images/cd.jpg" class="bg"/>
                    <h3>
                        郑州分公司
                    </h3>
                    <p>
                        <img src="../images/ic_home.png"/>
                        郑州市新郑市云港路与华夏大道世航之窗大厦B座907
                    </p>
                    <p>
                        <img src="../images/ic_phone.png"/>
                        15838346196
                    </p>
                    <p>
                        <img src="../images/ic_message.png"/>
                        mecoldfgo@xingyunyi.cn
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="links">
        <h2>
            合作伙伴
        </h2>
        <ul>
            <li>
                <img src="../images/图片 26(1).png">
            </li>
            <li class="cursor" @click="goLinks('https://www.shoppaas.com')">
                <img src="../images/shoppaas.jpg">
            </li>
            <li>
                <img src="../images/图片 62.png">
            </li>
            <li>
                <img src="../images/图片 63.png">
            </li>
            <li>
                <img src="../images/图片 70(1).png">
            </li>
            <li>
                <img src="../images/图片 71.png">
            </li>
            <li>
                <img src="../images/图片 74.png">
            </li>
            <li>
                <img src="../images/图片 84.png">
            </li>
        </ul>
    </div>

</div>
</template>
<script>
import indexTop from './base/index-top'
import producItem from './base/index-product-item'
import axios from 'axios'
import producItemImg from './base/product-item'
export default {
  name: 'index',
  components: {
    'index-top': indexTop,
    'product-item': producItem,
    'product-item-img': producItemImg
  },
  data () {
    return {
      postData: {
        'Contact': '',
        'Phone': ''
      },
      zx: ['美国专线', '德国专线', '澳洲专线', '法国专线', '英国专线', '加拿大专线', '意大利专线', '日本专线', '中东专线'],
      yz: ['中国邮政E邮宝', 'E特快'],
      kd: ['TNT', 'Fedex', 'DHL'],
      fba: ['FBA空派']
    }
  },
  methods: {
    add () {
      if (this.postData.Contact === '') {
        alert('必须填入联系人')
        return
      }
      if (this.postData.Phone === '') {
        alert('必须填入电话')
        return
      }
      axios({url: 'http://120.24.149.148:9518/api/CustomerMaintenance/PostMsg',
        method: 'post',
        data: this.postData,
        headers: {'Authorization': 'token 132A7468DE079C6CEB59F383A661E612'}}).then(response => {
        alert('提交成功，稍后会电话与您沟通详情！')
        this.postData.Contact = ''
        this.postData.Phone = ''
      })
    },
    goLinks (url) {
      if (!url) return false
      window.open(url, '_blank')
    }
  },
  created () {
    var that = this
    axios({url: 'http://wms.xingyunyi.cn/api/PublicChannel/All', method: 'get', params: {}}).then(response => {
      that.zx = []
      that.yz = []
      that.kd = []
      that.list = []
      for (var i = 0; i < response.data.Data.length; i++) {
        var item = response.data.Data[i]
        if (item.IsHot) {
          that.list.push(item)
        }
        if (item.IsShow) {
          if (item.ChannelType === 0) {
            that.zx.push(item.Name)
          } else if (item.ChannelType === 1) {
            that.kd.push(item.Name)
          } else if (item.ChannelType === 2) {
            that.yz.push(item.Name)
          } else if (item.ChannelType === 3) {
            that.fba.push(item.Name)
          }
        }
      }
    })
  }
}
</script>
<style scoped>
    .wx {
        position: fixed;
        display: flex;
        flex-direction: column;
        left: 30px;
        bottom: 30px;
        /* padding: 3px 3px 0 3px; */
        border-radius: 3px;
        width: 200px;
        text-align: center;
        z-index: 130;
    }
    .wx .wxitem {
        border:1px solid #ebeeee;
        background: #fff;
        border: 1px solid #ddd;
        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    }
    .wx .wxitem img{
        width:180px
    }
    .wx .hotline {
        border:1px solid #ebeeee;
        background: #fff;
        border: 1px solid #ddd;
        margin-bottom: 10px;
        color: #012072;
        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    }
    .hotline .hotline-img {
        width: 128px;
    }
    .wx .hotline p {
        margin: 0;
        padding: 10px 0;
        font-weight: 500;
    }
    .wx .hotline .phone {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
    }
    .hotline .phone img {
        margin-right: 4px;
    }

    .productItemV2{
        width:210px;
        height:180px;
        background:#ffffff;
        margin:0 25px;
        border-radius: 5px;
        display:block;
        float:left;
        text-align: center;
    }
    .productItemV2 h3{
        font-size: 22px;
    color: #4D4D4D;
    text-align: center;
    }
    .productItemV2 b{
        font-size: 13px;
        color: #999;
        text-align: center;
        padding-top: 8px;
    }

    .productItemV2  .iconfont {
        line-height: 90px;
        text-align: center;
        display: block;
        font-size: 60px;
        background-image: -webkit-gradient(linear, left top, left bottom, from(#005ADC), to(#1C77FA));
        background-image: linear-gradient(#005ADC, #1C77FA);
        background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(#005ADC), to(#1C77FA));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .iconfont {
        font-family: "iconfont" !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .index{background: #f5f5f5;}
    .links{
        background: #77a7fd;
        height:420px;
    }

    .links h2{
        font-size: 48px;
        color: #ffffff;
        margin-bottom: 10px;
        padding-top: 20px;
        text-align: center;;
    }

    .links ul{
        width:1300px;
        margin: auto;
        padding-left: 44px;
        box-sizing: border-box;
        overflow: hidden;
    }

    .links ul li{
        float:left;
        display: block;
        height: 94px;
        width: 264px;
        position: relative;
        margin-right: 50px;
        margin-top:40px;
        background: #fff;
        text-align: center;
        box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
        line-height: 90px;
        border:1px solid #ccc;
        box-sizing: border-box;
    }
    .links .cursor {
        cursor: pointer;
    }

    .links ul li img{
        vertical-align: middle;
        max-width:250px;
        max-height: 80px;
        top: 50%;
    }

    .about img{
        position: absolute;
        width: 600px;
        right: 0px;
        bottom: 100px;
    }
    .about{
        position: relative;
        width:1300px;
        box-sizing: border-box;
        margin:0 auto;
        margin-top:100px;
        clear: both;
        padding: 30px 30px 0 30px;
        background: #fff;
    }
    .about-text{
        width:640px;
        height: 500px;
    }
    .about-text p{
        font-size: 18px;;
        text-indent: 36px;
        line-height: 36px;;
    }
    .about-text h2{
        font-size: 48px;
        color:#10499f;
        margin-bottom: 10px;
    }

    .about-text h3{
        font-size: 24px;
        margin-bottom: 40px;
        font-weight: 400;

    }

    .product{
        width:1300px;
        margin: auto;
        margin-bottom: 40px;
    }

    .product-title{
        text-align: center;
        margin-bottom: 40px;
    }

    .product h2{
        font-size: 48px;
        margin-top: 20px;
        margin-bottom: 10px;
        font-weight: 400;
        color:#10499f
    }

    .product h3{
        font-size: 24px;
        margin-top:0;
        margin-bottom: 10px;
        font-weight: 400;
    }
    .products{
        width:1300px;
        margin: auto;
        height: 205px;;
        }
    .labels{
            width:1300px;
            margin: auto;
            height: 205px;;
    }
    .title2{
        text-align: center;
        color:#666;
        font-size: 28px;
    }

    .labelItem{
        width:620px;
        float:left;
        height:100px;
    }
    .labelItem *{
        color:#999
    }
    .labelItem .labelR{
        color:red;
    }
   .labels .labelItem .labelTitle{
        margin-bottom: 10px;
        padding: 0px;
    }
    .labelItem input{
        height:50px;
        border:none;
        line-height:50px;
        width:100%;
        background: #f3f3f3;
        padding-left: 10px;
        outline: none;
    }
    .labels button{
        cursor: pointer;
        width:400px;
        height:50px;
        line-height: 50px;
        display: block;
        background: #005ADC;
        margin:30px auto;
        color:#fff;
        font-size: 16px;
        border:none;
    }
    .productItemV2:hover h3,
    .productItemV2:hover b
    {
    color:#fff
    }
    .productItemV2:hover
    {
        background-color: #005ADC;
        -webkit-box-shadow: 2px 2px 14px rgba(0, 90, 220, 0.3);
        box-shadow: 2px 2px 14px rgba(0, 90, 220, 0.3);
    }

    .productItemV2:hover .iconfont {
        background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#fff));
        background-image: linear-gradient(#fff, #fff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
}
</style>

<style scoped>
a{text-decoration: none;}

    .news{
        width:1300px;
        margin: auto;
        height: 780px;;
        margin-top:30px;
    }

     .text p{
        padding: 30px 0;
        padding-top:0;
        margin: 0;
    }

    .text2{
        background: #fff;
        box-shadow: 1px 2px 5px -2px rgb(0 0 0 / 10%);
        padding:20px;
        border-radius: 5px;
    }

    .text .title{
        font-size: 48px;
        color:#10499f;
        margin-bottom: 10px;
        font-weight: 800;
    }
    .contactusItem{
        margin-top: 20px;
    }
    .contactusItem{
        width: calc(100% / 3 - 25px);
        float: left;
        height: 300px;
        margin-right: 35px;
        background: #fff;
        box-shadow: 1px 2px 14px -2px rgb(0 0 0 / 10%);
    }
    .contactusItem .bg{
        width: 100%;
        height: 131px;
        border-radius: 5px 5px 0 0;

    }
    .contactusItem h3{
        font-size: 18px;
        margin:  15px 15px;;
    }
    .contactusItem p{
        margin:  15px 15px;;
        vertical-align: middle;
        font-size: 12px;
    }
    .contactusItem img{
        margin-right: 10px;
        vertical-align: middle;
    }

</style>



// WEBPACK FOOTER //
// src/components/index.vue